export default "__VITE_ASSET__DNDfgy5m__"